import { render, staticRenderFns } from "./ProductPanel.vue?vue&type=template&id=6725f8d2&scoped=true&"
import script from "./ProductPanel.vue?vue&type=script&lang=js&"
export * from "./ProductPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductPanel.vue?vue&type=style&index=0&id=6725f8d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6725f8d2",
  null
  
)

export default component.exports